module.exports = __webpack_public_path__ + "static/media/screen2.d351c540.png";